var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import gql from "graphql-tag";
import { graphql, Query } from "react-apollo";
// TODO: Add another query that finds only user specific owned addresses (ensure addresses returned are only those owned by current user for this)
// finds all addresses submitted by ALL users
export var findAddressesQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query FindAddressesQuery {\n    findAddresses {\n      index\n      id\n      address\n      created\n      used\n      timesUsed\n      lastUsedTime\n      userId\n      payRef\n      xpubIdentifier\n      derivationPath\n      sig\n      sig_id\n      sig_account\n      owner {\n        id\n        email\n      }\n    }\n  }\n"], ["\n  query FindAddressesQuery {\n    findAddresses {\n      index\n      id\n      address\n      created\n      used\n      timesUsed\n      lastUsedTime\n      userId\n      payRef\n      xpubIdentifier\n      derivationPath\n      sig\n      sig_id\n      sig_account\n      owner {\n        id\n        email\n      }\n    }\n  }\n"])));
// export HOC
export var withFindAddresses = graphql(findAddressesQuery, {
    props: function (_a) {
        var data = _a.data;
        var addresses = [];
        if (data && !data.loading && data.findAddresses) {
            addresses = data.findAddresses;
        }
        return {
            addresses: addresses,
            // if data exists return data otherwise return false
            loading: data ? data.loading : false,
        };
    },
});
var FindAddresses = /** @class */ (function (_super) {
    __extends(FindAddresses, _super);
    function FindAddresses() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FindAddresses.prototype.render = function () {
        var children = this.props.children;
        return (React.createElement(Query, { query: findAddressesQuery, fetchPolicy: "cache-and-network" }, function (_a) {
            var data = _a.data, loading = _a.loading, refetch = _a.refetch;
            refetch();
            var addresses = [];
            if (data && data.findAddresses) {
                addresses = data.findAddresses;
            }
            return children({
                addresses: addresses,
                loading: loading,
            });
            // return {
            //   addresses,
            //   // if data exists return data otherwise return false
            //   loading,
            // };
        }));
    };
    return FindAddresses;
}(React.PureComponent));
export { FindAddresses };
var templateObject_1;
// Previous form before refactoring
// import gql from "graphql-tag";
// import { graphql } from "react-apollo";
// import {
//   FindAddressesQuery_findAddresses,
//   FindAddressesQuery,
// } from "../../../schemaTypes";
// // TODO: Add another query that finds only user specific owned addresses (ensure addresses returned are only those owned by current user for this)
// // finds all addresses submitted by ALL users
// export const findAddressesQuery = gql`
//   query FindAddressesQuery {
//     findAddresses {
//       index
//       id
//       address
//       created
//       used
//       timesUsed
//       lastUsedTime
//       userId
//       payRef
//       owner {
//         id
//         email
//       }
//     }
//   }
// `;
// export interface WithFindAddresses {
//   addresses: FindAddressesQuery_findAddresses[];
//   loading: boolean;
// }
// // export HOC
// export const withFindAddresses = graphql<
//   any,
//   FindAddressesQuery,
//   {},
//   WithFindAddresses
// >(findAddressesQuery, {
//   props: ({ data }) => {
//     let addresses: FindAddressesQuery_findAddresses[] = [];
//     if (data && !data.loading && data.findAddresses) {
//       addresses = data.findAddresses;
//     }
//     return {
//       addresses,
//       // if data exists return data otherwise return false
//       loading: data ? data.loading : false,
//     };
//   },
// });
//# sourceMappingURL=index.js.map